import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../components/SectionFormContainer'
import DaycareWizardContext from './DaycareWizardContext'
import useDaycareVisit from '../../../hooks/useDaycareVisit'
import useSelectedHousehold from '../../../hooks/useSelectedHousehold'
import { formatNumsToDollars } from '../../../utils'
import WizardAlert from '../components/WizardAlert'
import moment from 'moment'
import { DEFAULT_RESPONSES, DEFAULT_WELCOME_SURVEY_1_CONFIG } from './config'
import { Typography } from '@material-ui/core'

const Playgroup = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(DaycareWizardContext)
	const { attr, title = '', subtext = '', pet } = props
	const { loading, daycare } = useDaycareVisit()
	const { isVip, isPetCare } = useSelectedHousehold()

	const handleSelection = useCallback(
		(question_id, response) => {

            const responses = wizard_state?.welcome_day_survey ? [... wizard_state?.welcome_day_survey] : []

            const exists = responses.find(r => r.question_id === question_id && r.pet_id === pet._id)

            if (exists) {
                exists.answer_id = response
            } else {
                responses.push({
                    question_id,
                    answer_id: response,
                    pet_id: pet._id
                })
            }

			const newValues = { ...wizard_state, welcome_day_survey: responses }


			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues]
	)


    const mapOptions = (question) => {

        const responses = wizard_state?.welcome_day_survey || []

        return question.responses.map(o => {

            const selected = !!responses.find(r => r.question_id === question.id && r.answer_id === o.id && r.pet_id === pet._id)

            return {
                title: o.text,
                id: o.id,
                question_id: question.id,
                selected,
                onSelected: () => handleSelection(question.id, o.id)
            }
        })
    }

	return (
		<SectionFormContainer title={`${title} for ${pet.name}`} subtext={subtext}>
			{DEFAULT_WELCOME_SURVEY_1_CONFIG.map((question) => {
                return (
                    <div style={{
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        marginBottom: 36
                    }}>
                        <Typography variant='body1' style={{ fontWeight: 'bold', marginBottom: 16 }}>{question.question}</Typography>
                        <OptionsMenu options={mapOptions(question)}/>
                    </div>
                )
            })}
			
		</SectionFormContainer>
	)
}

export default Playgroup
